<template>
    <div class="mt-5">
        <vs-tabs alignment="fixed">
            <vs-tab label="Periodic Reports" icon-pack="feather" icon="icon-clock">
              <vx-card  title="Periodic Reports" subtitle="Generate periodic reports"  class="app-fixed-height">
            
                <div class="vx-col w-full mb-base">
                    <periodic-reports ></periodic-reports >
                </div>
              </vx-card>
            
            

            </vs-tab>
<!-- END Periodic Reports -->
<!-- Monthly Reports -->

            <vs-tab label="Monthly Reports" icon-pack="feather" icon="icon-calendar">
              <vx-card  title="Monthly Reports" subtitle="Generate monthly reports"  class="app-fixed-height">
            
                <div class="vx-col w-full mb-base">
                  <monthly-reports></monthly-reports>
                 
                </div>
              </vx-card>
            </vs-tab>
<!-- END Monthly Reports  -->
<!-- Annual Reports -->

            <vs-tab label="Annual Reports" icon-pack="feather" icon="icon-calendar">
              <vx-card  title="Annual Reports" subtitle="Generate Annual Reports"  class="app-fixed-height">
                <div class="vx-col w-full mb-base">
                  <annual-reports></annual-reports>
                </div>
              </vx-card>
            </vs-tab>
<!-- END Annual Reports  -->
<!-- BIR Reports -->
            <vs-tab label="BIR Reports" icon-pack="feather" icon="icon-credit-card">
                <vx-card title="BIR Reports" subtitle="Generate BIR Reports"  class="app-fixed-height">
                  <div class="vx-col w-full mb-base">
                    <bir-reports></bir-reports>
                  </div>
              </vx-card>
            </vs-tab>
<!-- END BIR Reports -->
        </vs-tabs>
    </div>
</template>
<script>
import PeriodicReports from './PeriodicReports'
import MonthlyReports from './MonthlyReports'
import AnnualReports from './AnnualReports'
import BIRReports from './BIRReports'
export default {
  components: {
    PeriodicReports,
    MonthlyReports,
    AnnualReports,
    BIRReports
  },
  data() {
    return {

    }
  },
  created() {
    const payload = {
                    pageNumber: 1,
                    pageSize: -1,
                    sortBy: 'CreatedOn',
                    sortOrder: 'Desc',
        }
        this.$store.dispatch('tenants/getAllTenants', payload).catch(err => { console.error(err) })
    const data = {
            pageNumber: -1,
            pageSize: -1
        }

        this.$store.dispatch('hrms/getAllEmployee', data)
            .then(res => { this.$vs.loading.close() })
            .catch(err => { console.error(err) })
  },
  computed : {
    
  },

}
</script>
